import React, { Component } from "react";
import {Container, Row, Col} from "reactstrap";

export default class NoMatchContent extends Component{
    render(){
        return(
            <>
            <section className="section">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-lg-1">
                  <div className="d-flex px-3">
                    <div className="pl-4">
                      <h2 className="display-2">Cookies policy</h2>

                      <h3 className="display-3">What are cookies</h3>
                      
                      <p>
                      As is common practice with almost all professional websites this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it and why we sometimes need to store these cookies. We will also share how you can prevent these cookies from being stored however this may downgrade or 'break' certain elements of the sites functionality.
                      <br />
                      For more general information on cookies, please read "What Are Cookies".
                      </p>
                      <h3 className="display-3">How we use cookies</h3>
                      <p>
                      We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.
                      </p>
                      <h3 className="display-3">Disabling Cookies</h3>
                      <p>
                      You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of the this site. Therefore it is recommended that you do not disable cookies.
                      </p>
                      <h3 className="display-3">The cookies we set</h3>
                      <p>
                        <ul>
                          <li> Account related cookies
                                If you create an account with us then we will use cookies for the management of the signup process and general administration. These cookies will usually be deleted when you log out however in some cases they may remain afterwards to remember your site preferences when logged out. </li>
                          <li>
                          Login related cookies
                          We use cookies when you are logged in so that we can remember this fact. This prevents you from having to log in every single time you visit a new page. These cookies are typically removed or cleared when you log out to ensure that you can only access restricted features and areas when logged in.
                          </li>
                          <li>
                            Site preferences cookies
                            In order to provide you with a great experience on this site we provide the functionality to set your preferences for how this site runs when you use it. In order to remember your preferences we need to set cookies so that this information can be called whenever you interact with a page is affected by your preferences.
                          </li>
                        </ul>
                      </p>
                      <h3 className="display-3"> Third Party Cookies </h3>
                      <p>
                      In some special cases we also use cookies provided by trusted third parties. The following section details which third party cookies you might encounter through this site.
                      This site uses Google Analytics which is one of the most widespread and trusted analytics solution on the web for helping us to understand how you use the site and ways that we can improve your experience. These cookies may track things such as how long you spend on the site and the pages that you visit so we can continue to produce engaging content.
                      For more information on Google Analytics cookies, see the official Google Analytics page.
                      </p>
                      <h3  className="display-3">
                        More information
                      </h3>
                      <p>
                      Hopefully that has clarified things for you and as was previously mentioned if there is something that you aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with one of the features you use on our site. 
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            </section>
            </>
        )
    }
}
/* 
<h1> Our portal is currently being developed. If you want to know better what we do, check out the 
<a href="/demo">demo</a>. If you like it, <a href="/contact"> contact us! </a></h1> */